<template>
  <v-row dense>
    <v-list dense class="pl-2 pt-0 pb-1" color="var(--v-cards-base)">
      <small v-show="selectedFilters.length > 0" class="float-left ma-0 mb-1">{{$t('general.filters')}}: </small>
      <v-list-item v-for="(item, i) in selectedFilters" :key="i" class="selected-filter-item pa-0 pl-1 pr-5 ml-1 mb-1 float-left">
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title
            v-text="item.title + ': ' + item.value"
            class="pa-1 ma-0"
          ></v-list-item-title>
          <v-list-item-icon class="ma-0 pa-0" @click="removeFilter(item)">
            <v-icon size="14" color="var(--v-caption-light-base)">mdi-close</v-icon>
          </v-list-item-icon>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-show="selectedFilters.length > 1" class="selected-filter-item general-item pa-0 pl-1 pr-5 ml-1 mb-1 float-left">
        <v-list-item-content class="pa-0 ma-0">
          <v-list-item-title
            v-text="$t('general.clearAllFilters')"
            class="pa-1 ma-0"
          ></v-list-item-title>
          <v-list-item-icon class="ma-0 pa-0" @click="removeAllFilters()">
            <v-icon size="14" color="var(--v-caption-light-base)">mdi-close</v-icon>
          </v-list-item-icon>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-row>
</template>

<script>
import { EventBus } from '@/router/bus'

export default {
  name: 'filter-summary',
  data () {
    return {
      selectedFilters: []
    }
  },
  props: {
    targetName: String
  },
  created () {
    EventBus.$on('filter-' + this.targetName, this.populateFilters)
  },
  beforeDestroy () {
    EventBus.$off('filter-' + this.targetName, this.populateFilters)
  },
  methods: {
    populateFilters (filters) {
      this.selectedFilters = filters.params
      // console.log(filters.params)
    },
    removeFilter (item) {
      EventBus.$emit('removeFilter', {
        targetName: this.targetName,
        field: item.field
      })
    },
    removeAllFilters () {
      EventBus.$emit('removeAllFilters', {
        targetName: this.targetName
      })
    }
  }
}

</script>

<style scoped>
</style>
